/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-03 18:28:23
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-14 16:24:29
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/Components/EditorHOC/index.tsx
 */
/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-24 14:18:07
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-03 15:15:10
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/Components/HOC/index.tsx
 */
import Warning from '@/src/components/Antd/Modal/WarningModal';
import NoPermission from '@/src/components/NoPermission';
import MultiLangDropDown from '@/src/constrains/SalesChannelMultiLanguageSelect/MultiLangDropDown';
import TopLeft from '@/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import TopRight from '@/src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
import qs from 'query-string';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { ErrorBoundary } from 'src/components/ErrorBoundary';
import { useQueryLanguageListContentEditor } from 'src/constrains/SalesChannelMultiLanguageSelect';
import { isPrimaryLanguage } from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import { useI18n } from 'src/hooks/useRouterChange';
import { store } from 'src/store';
import { NEW } from 'src/tools/constant';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';
import { switchUuidHooks } from '../hooks/customHooks';

const salesChannelMultiLanguageParams = {
  [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
  [EnumSalesChannelMultiLanguage.multiLanguageForceUpdate]: true,
};

const salesChannelMultiLanguageParamsCreateNew = {
  [EnumSalesChannelMultiLanguage.multiLanguageUsePrimaryLanguage]: true,
};

const salesChannelMultiLanguageQueryParams = {
  [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
  //  salesChannelMultiLanguageUpdate: true,multiLanguageUsePrimaryLanguage
};
export enum EnumPage {
  legalPage = 'legalPageUuid',
  termsAndCondition = 'TcUuid',
}
export const urlKey = {
  [EnumPage.legalPage]: 'legalPageUuid',
  [EnumPage.termsAndCondition]: 'TcUuid',
};

const generateListUrl = ({ type, uuid }) => {
  if (type === EnumPage.legalPage) {
    return `/salesChannel/legalPage/list/${uuid}`;
  }
  if (type === EnumPage.termsAndCondition) {
    return `/salesChannel/termsAndCondition/list/${uuid}`;
  }
  return '/';
};

const generateBreadCumThird = ({ type }) => {
  if (type === EnumPage.legalPage) {
    return getI18nFromGeneral('general.sider.legalPage');
  }
  if (type === EnumPage.termsAndCondition) {
    return getI18nFromGeneral('general.sider.terms');
  }
  return '/';
};

const generateHooksUrl = ({ type }) => {
  if (type === EnumPage.legalPage) {
    return `/salesChannel/legalPage/editor`;
  }
  if (type === EnumPage.termsAndCondition) {
    return `/salesChannel/termsAndCondition/editor`;
  }
  return '/';
};

const _getState = () => {
  return store.getState();
};
const _modal = () => {
  return {
    open: false,
    title: '',
    content: '',
    okText: '',
    onOk: null,
    cancelText: '',
    onCancel: null,
  };
};

const EditorHOC = (Component: any, obj) => {
  const {
    getHasModified,
    getName,
    _key,
    validation,
    getState,
    convertDataFromReduxToServer,
    submit,
    deleteFunction,
    getLoaded,
    getUuid,
    updateEssentialData,
    getData,
    resetData,
    getLastModified,
    getPermissions,
  } = obj;

  const WrappedComponent = (props) => {
    const i18n = useI18n();
    const getI18n = (str) => i18nGet(i18n, str);
    const { isPrimary } = props;
    const currentLanguage = useQueryLanguageListContentEditor();
    const [deleteModal, setDeleteModal] = React.useState(_modal());
    const m: any = useLocation();
    const { index } = qs.parse(m.search);

    const _d = useDispatch();
    const _h = useHistory();
    const _p: { uuid: string } = useParams();
    const { canView, canDelete, canEdit } = getPermissions
      ? getPermissions(_p.uuid)
      : {
          canView: true,
          canDelete: true,
          canEdit: true,
        };
    const _isNew = _p[_key] === NEW;
    const url = generateListUrl({ type: _key, uuid: _p.uuid });

    React.useEffect(() => {
      if (canView) {
        if (_p[_key] === NEW) {
          _d(updateEssentialData({ salesChannelUuid: _p.uuid, index }));
        } else {
          _d(
            getData({
              uuid: _p[_key],
              params: salesChannelMultiLanguageQueryParams,
            }),
          );
        }
      }
    }, [currentLanguage]);

    React.useEffect(() => {
      return () => {
        _d(resetData());
      };
    }, []);

    switchUuidHooks({
      getUuid,
      _key,
      url: generateHooksUrl({ type: _key }),
    });

    const resetCloseModal = () => {
      setDeleteModal(_modal());
    };
    const onDiscard = (state?) => {
      _h.push({
        pathname: url,
        state: (state || {}).skipNotice,
      });
    };
    const _delete = () => {
      deleteFunction(_p[_key]).then(() => {
        onDiscard({
          skipNotice: true,
        });
      });
    };
    const onDelete = () => {
      if (_key === EnumPage.legalPage) {
        const _state: any = getState()(_getState());
        const { hasLinkedToTC } = _state || {};
        if (hasLinkedToTC) {
          setDeleteModal({
            open: true,
            title: getI18n('general.deletepage'),
            content: getI18n('general.deletepagecontent'),
            okText: getI18n('general.delete'),
            onOk: _delete,
            cancelText: getI18n('general.cancel'),
            onCancel: resetCloseModal,
          });
          return;
        }
      }
      setDeleteModal({
        open: true,
        title: getI18n('general.deletepage'),
        content: getI18n('general.deletepageconfirm'),
        okText: getI18n('general.delete'),
        onOk: _delete,
        cancelText: getI18n('general.cancel'),
        onCancel: resetCloseModal,
      });
    };

    const onSubmit = () => {
      _d(validation(_isNew ? true : isPrimary));
      const _state: any = getState()(_getState());
      const { dataValid } = _state;

      if (dataValid) {
        const _data = convertDataFromReduxToServer(_state);
        _d(
          submit({
            data: _data,
            params: _isNew
              ? salesChannelMultiLanguageParamsCreateNew
              : salesChannelMultiLanguageParams,
          }),
        );
      }
    };
    const hasModified = useSelector(getHasModified());

    const _loaded: any = getLoaded ? useSelector(getLoaded()) : true;
    const { loaded } = _loaded || {};

    const topRight = (
      <TopRight
        {...(_isNew ? {} : { onDelete, displayDuplicateGroup: true })}
        extraLeft={
          _isNew ? null : (
            <div style={{ marginRight: 8 }}>
              <MultiLangDropDown
                hasModified={hasModified}
                salesChannelUuidKey='uuid'
              />
            </div>
          )
        }
        onDiscard={onDiscard}
        onSubmit={onSubmit}
        onSaveDisable={!hasModified || !canEdit}
        disableDelete={!canDelete}
      />
    );

    const _props = {
      history: _h,
      params: _p,
      dispatch: _d,
      hasModified,
      onDiscard,
      selector: useSelector,
      loaded,

      topLeft: (
        <_TopLeft
          getLastModified={getLastModified}
          loaded={loaded}
          getName={getName}
          isNew={_isNew}
          onDiscard={onDiscard}
          url={url}
          breadcrumbName={generateBreadCumThird({ type: _key })}
        />
      ),
      topRight,
    };

    return canView ? (
      <ErrorBoundary>
        {deleteModal.open && (
          <Warning
            visible
            header={deleteModal.title}
            onOk={deleteModal.onOk}
            okText={deleteModal.okText}
            cancelText={deleteModal.cancelText}
            onCancel={deleteModal.onCancel}>
            {deleteModal.content}
          </Warning>
        )}
        <Component {...props} {..._props} />
      </ErrorBoundary>
    ) : (
      <NoPermission />
    );
  };
  return _SelectHOC(WrappedComponent);
};
export default EditorHOC;
const _TopLeft = ({
  getLastModified,
  getName,
  isNew,
  onDiscard,
  url,
  breadcrumbName,
  loaded,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const lastModified = useSelector(getLastModified());
  const _isNew = isNew;
  const _name: { name: string; salesChannelName: string } = useSelector(
    getName(),
  );
  const { name, salesChannelName } = _name;

  const displayName = React.useMemo(() => {
    return name;
  }, [lastModified, loaded]);
  const breadcrumbData = [
    {
      url: '/',
      name: getI18n('general.sider.home'),
    },
    {
      url: '/salesChannel',
      name: salesChannelName,
    },
    {
      url: url,
      name: breadcrumbName,
    },
    {
      url: '',
      name: _isNew ? getI18n('general.addNewPage') : displayName,
    },
  ];

  return <TopLeft goBack={onDiscard} breadcrumbData={breadcrumbData} />;
};

export const _SelectHOC = (Component) => {
  const _Component = (props) => {
    // console.log('__isCurrentSalesChannel', props.__isCurrentSalesChannel);
    const { __isCurrentSalesChannel, ...rest } = props;
    const isOnPrimaryLanguage = useSelector(isPrimaryLanguage());
    return __isCurrentSalesChannel ? (
      <Component {...rest} isPrimary={isOnPrimaryLanguage} />
    ) : null;
  };
  return _Component;
};
